import { render, staticRenderFns } from "./GamePage.vue?vue&type=template&id=010b5503&scoped=true&"
import script from "./GamePage.vue?vue&type=script&lang=js&"
export * from "./GamePage.vue?vue&type=script&lang=js&"
import style0 from "./GamePage.vue?vue&type=style&index=0&id=010b5503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b5503",
  null
  
)

export default component.exports